var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "filtersContainer" }, [
      _c("div", { staticClass: "disp-flex" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              { staticClass: "demo-form-inline", attrs: { inline: true } },
              [
                _c("span", [_vm._v(" " + _vm._s(_vm.$t("channel")) + ": ")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "mr-10",
                    attrs: {
                      value: _vm.channelFilter,
                      size: "mini",
                      multiple: "",
                      "collapse-tags": ""
                    },
                    on: { change: _vm.handleChannelFilterChange }
                  },
                  _vm._l(_vm.DEFAULT_CHANNEL_FILTERS, function(filter) {
                    return _c("el-option", {
                      key: filter.value,
                      attrs: {
                        label: _vm.$translate.channel(filter.value),
                        value: filter.value
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v(" " + _vm._s(_vm.$t("language")) + ": ")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "mr-10",
                    attrs: {
                      value: _vm.languageFilter,
                      size: "mini",
                      multiple: "",
                      "collapse-tags": ""
                    },
                    on: { change: _vm.handleLanguageFilterChange }
                  },
                  _vm._l(_vm.languages, function(language, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.$translate.language(
                          language.locale.substring(0, 2)
                        ),
                        value: language.locale
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.$t("toneOfVoice")) + ": ")
                ]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "mr-10",
                    attrs: {
                      value: _vm.toneOfVoiceFilter,
                      size: "mini",
                      multiple: "",
                      "collapse-tags": ""
                    },
                    on: { change: _vm.handleToneOfVoiceFilterChange }
                  },
                  _vm._l(_vm.DEFAULT_TONE_FILTERS, function(filter) {
                    return _c("el-option", {
                      key: filter.value,
                      attrs: {
                        label: _vm.$translate.tone_of_voice(filter.value),
                        value: filter.value
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.handleFilter }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("applyFilters")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto" }, [
          _c(
            "div",
            { staticClass: "disp-flex" },
            [
              _c(
                "el-input",
                {
                  staticClass: "mr-5",
                  attrs: { size: "mini", placeholder: "" },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onSearch.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.searchTerm,
                    callback: function($$v) {
                      _vm.searchTerm = $$v
                    },
                    expression: "searchTerm"
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "prefix" },
                    slot: "prefix"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.onSearch }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(_vm.$t("search")) + "\n\t\t\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.onReset }
                },
                [_vm._v("\n\t\t\t\t\t\tReset\n\t\t\t\t\t")]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.availableTemplates && _vm.availableTemplates.length > 0
      ? _c(
          "div",
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.availableTemplates },
                on: {
                  "row-click": _vm.handleTemplateClick,
                  "sort-change": _vm.handleSort
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "channel",
                    label: _vm.$t("channel"),
                    sortable: "custom",
                    "column-key": "channel"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$translate.channel(scope.row.channel)
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2661842040
                  )
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "template_id",
                    label: "ID",
                    sortable: "custom",
                    width: "450",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              { staticClass: "flex justify-between" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "flex items-center" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(scope.row.template_id) +
                                        _vm._s(
                                          _vm.translate_template_id(
                                            scope.row.template_id
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "template-id",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.handleOpenInNewTabClick(
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        "icon-class": "up-right-from-square"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3091445637
                  )
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "tone_of_voice",
                    label: _vm.$t("toneOfVoice"),
                    sortable: "custom"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$translate.tone_of_voice(
                                    scope.row.tone_of_voice
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    742545080
                  )
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "locale",
                    label: _vm.$t("language"),
                    sortable: "custom"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$translate.language(
                                    scope.row.locale.substring(0, 2)
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    987283730
                  )
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "legal_entity_by_reference.registration_name",
                    label: _vm.$t("legalEntity"),
                    sortable: "custom",
                    width: "192"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total > 0"
                    }
                  ],
                  staticClass: "p-5",
                  attrs: {
                    total: _vm.total,
                    page: _vm.page,
                    limit: _vm.queryVars.limit
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.page = $event
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryVars, "limit", $event)
                    },
                    pagination: _vm.paginate
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.availableTemplates && _vm.availableTemplates.length === 0
      ? _c("div", [
          _c("div", { staticClass: "mt-40 mb-20" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.$t("noTemplatesAvailable")) + "\n\t\t"
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }